import { ofType } from "redux-observable";
import { filter, map, retry, switchMap } from "rxjs/operators";
import { selectIsEventRunning } from "../../../selectors/selectEventInfo";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { utilEvent } from "../../../utils/utilEvent";
import { TypeActionEventInfo } from "../../info/event/actionEventInfo";
import { actionPVPInfoReceived } from "../actionPvp";
export var epicPVPInfoRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionEventInfo.Received), filter(function (action) {
        var playerId = selectOwnPlayerId(state$.value);
        var pvpEvents = action.eventInfo
            ? action.eventInfo.pvpMapLeagueEvent.slice() : [];
        var normalizedPVPEvents = utilEvent.timestampModifier(pvpEvents);
        var isPVPEventRunning = normalizedPVPEvents.find(function (pvpEvent) { return selectIsEventRunning(pvpEvent); }) != undefined;
        return playerId != undefined && isPVPEventRunning;
    }), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        var pvpEvents = action.eventInfo
            ? action.eventInfo.pvpMapLeagueEvent.slice() : [];
        var normalizedPVPEvents = utilEvent.timestampModifier(pvpEvents);
        var RunningPVPEvent = normalizedPVPEvents.find(function (pvpEvent) {
            return selectIsEventRunning(pvpEvent);
        });
        return deps.netSend({
            id: CommandCode.PvpLeagueInfo,
            props: {
                eventId: RunningPVPEvent.eventId,
                playerId: playerId,
            },
        });
    }), retry(), map(function (response) { return actionPVPInfoReceived(response); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/pvp/epics/epicPVPInfoRequest.ts
// module id = 2108
// module chunks = 3